import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {BehaviorSubject, catchError, map, Observable, of, tap} from 'rxjs';
import { environment } from '../../environments/environment';
import { CandidatesApplied } from '../models/Mission';

@Injectable({
  providedIn: 'root',
})
export class CandidatService {
  imageUploadHeader: HttpHeaders;
  private cachedCandidatesSubject = new BehaviorSubject<any[] | null>(null);
  candidates$ = this.cachedCandidatesSubject.asObservable();
  
  constructor(private http: HttpClient) {}
  upadateCandidat(body: any, id: any): Observable<any> {
    return this.http.put(`${environment.api.BASE_URL}/api/candidats/${id}`, body);
  }
  candidatureFilter(body: any, establishmentId: number): Observable<any> {
    return this.http.post(`${environment.api.BASE_URL}/api/etablissements/${establishmentId}/filter`,
      body
    );
  }
  getCondidatById(id: any): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/api/candidats/${id}`);
  }

  getCandidatFullnameById(id: any): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/api/candidats/${id}/fullname`).pipe(
      catchError(error => {
        console.error('Error fetching candidate fullname:', error);
        return of({ id: id, fullname: 'Unknown' });
      })
    );
  }
  missionAndPlanning(id: any): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/candidat/planning/${id}`);
  }
  uploadFileCandidat(body: any, id: any) {
    return this.http.post(
      `${environment.api.BASE_URL}/api/candidats/files/upload/${id}`,
      body
    );
  }
  deleteFile(id: any, fileName: any) {
    return this.http.delete(
      `${environment.api.BASE_URL}/api/candidats/${id}/files/delete/${fileName}`
    );
  }
  filterPermanat(body: any) {
    return this.http.post(`${environment.api.BASE_URL}/filter`, body);
  }
  getFilterPermanat(id: any) {
    return this.http.get(`${environment.api.BASE_URL}/filter/${id}`);
  }

  getCandidatDetailByIdEstaId(candidatId: any, establishmentId: number): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/api/candidats/${candidatId}?establishmentId=${establishmentId}`);
  }

  getCandidatDetailByIdEstaIdV2(candidatId: any, establishmentId: number): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/api/v2/candidats/${candidatId}?establishmentId=${establishmentId}`);
  }

  getEvaluationByCandidatId(candidatId: any): Observable<any> {
    return this.http.get(`${environment.api.BASE_URL}/api/missions/evaluation/candidat/${candidatId}`);
  }

  // getAll(): Observable<any> {
  //   return this.http.get(`${environment.api.BASE_URL}/api/candidats`);
  // }

  getAll(): Observable<any> {
    if (this.cachedCandidatesSubject.value) {
      return of(this.cachedCandidatesSubject.value);
    }
    return this.http.get<any[]>(`${environment.api.BASE_URL}/api/candidats-without-mission`).pipe(
      tap((data) => {
        this.cachedCandidatesSubject.next(data);
      }),
      catchError((error) => {
        console.error('Failed to fetch establishments', error);
        throw error;
      })
    );
  }

  //@deprecated use pagination method
  getAgencyCandidates(): Observable<any> {
    if (this.cachedCandidatesSubject.value) {
      return of(this.cachedCandidatesSubject.value);
    }

    const token = localStorage.getItem('token');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get<any[]>(`${environment.api.BASE_URL}/api/candidats/agency`, { headers })
      .pipe(
        tap((data) => {
        this.cachedCandidatesSubject.next(data);
        }),
        catchError(error => {
          console.error('Error fetching agency candidates:', error);
          return of([]);
        })
      );
  }

  getAgencyCandidatesWithPagination(offset: number, size: number, search: string = '', typeSecteurIds: number[] = [], proStatus: string = ''): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    let url = `${environment.api.BASE_URL}/api/candidats/agency/paginated?offset=${offset}&size=${size}`;
    if (search && search.trim()) {
      url += `&search=${encodeURIComponent(search.trim())}`;
    }
    // B2 (client clinique — P3) : filtres secteurs (Médecins=1 / Infirmier=2) et statut pro (B1).
    typeSecteurIds.forEach((id) => {
      url += `&typeSecteurIds=${id}`;
    });
    if (proStatus && proStatus.trim()) {
      url += `&proStatus=${encodeURIComponent(proStatus.trim())}`;
    }
    return this.http.get<any>(url, { headers }).pipe(
      catchError(error => {
        console.error('Error fetching paginated agency candidates:', error);
        return of({ data: [], total: 0, totalPages: 0, pageNumber: 0, pageSize: size, hasNext: false, hasPrevious: false });
      })
    );
  }

  getOnlyAvailbleCandidats(missionId:any): Observable<CandidatesApplied[]> {
    return this.http.get<any[]>(`${environment.api.BASE_URL}/api/candidats-available/${missionId}`).pipe(
      map((data) => 
        data.map(item => ({
          candidateName: item.fullname,
          candidatePhoto: item.photo,
          candidatId: item.id,
        }) as CandidatesApplied)
      ),
      catchError((error) => {
        console.error('Failed to fetch candidates', error);
        throw error;
      })
    );
  }

  affectCandidatToMission(agecnyAffectMisisonDto: { candidatId: number; missionId: number; agencyId?: number | null }): Observable<any> {
    return this.http.put(`${environment.api.BASE_URL}/api/agency/affect/mission`, agecnyAffectMisisonDto).pipe(
      tap((response) => {
        console.log('Mission successfully affected to candidate:', response);
      }),
      catchError((error) => {
        console.error('Failed to affect mission to candidate', error);
        throw error;
      })
    );
  }

}
